import {createStyles, makeStyles} from '@material-ui/core'
import {Colors} from 'components/common/useBaseStyle'

const ProductOperationOrganization = () =>
  createStyles({
    root: {
      marginTop: '25px',
    },
    downloads: {
      display: 'flex',
      justifyContent: 'space-between',
      marginTop: '15px',
      alignItems: 'center',
    },
    listTabs: {
      display: 'flex',
    },
    activeTabs: {
      color: '#0bc7c8 !important',
    },
    active: {
      height: '3px',
      borderRadius: '2px',
      backgroundColor: '#0bc7c8',
      marginBottom: '-2.5px',
    },
    tabsUnderline: {
      display: 'flex',
      borderBottom: '2px solid #e5e7eb',
      position: 'relative',
    },
    tabUnderline: {
      padding: '16px',
      background: 'none',
      border: 'none',
      fontSize: '15px',
      fontWeight: 600,
      color: '#6b7280',
      cursor: 'pointer',
      transition: 'all 0.3s ease',
      position: 'relative',
      '&:hover': {
        color: '#374151',
      },
    },
    underlineIndicator: {
      position: 'absolute',
      bottom: '-2px',
      height: '3px',
      background: 'linear-gradient(90deg, #3b82f6, #8b5cf6)',
      borderRadius: '2px 2px 0 0',
      transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
    },
    table: {
      position: 'relative',
      minWidth: 880,
      color: 'red',
      marginTop: '25px',
      '& th': {borderLeft: '1px solid #dfdfdf'},
      '& td': {
        color: Colors.text.content,
        fontSize: '0.8125rem',
        lineHeight: 2,
        paddingTop: 6,
        paddingBottom: 6,
        height: 43,
        borderLeft: '1px solid #dfdfdf',
      },
      '& td:last-child': {
        borderRight: '1px solid #dfdfdf',
      },
    },
    cellRedirect: {
      cursor: 'pointer',
      maxWidth: 400,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
    tableHeader: {
      height: 42,
      backgroundColor: Colors.tableHeaderBackground,
      verticalAlign: 'middle',
      borderRadius: 10,
      '& th': {
        color: Colors.text.content,
        fontSize: '0.8125rem',
        lineHeight: '1rem',
        fontWeight: 'bold',
      },
    },
    rowCell: {
      cursor: 'pointer',
      '&:hover': {
        backgroundColor: '#F8F8F8',
      },
    },
    tableBody: {
      '&:hover': {
        backgroundColor: '#F8F8F8',
      },
    },
  })
const useProductOperationOrganizationStyles = makeStyles(
  ProductOperationOrganization,
)
export default useProductOperationOrganizationStyles
